import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';

const toggleAutoApproveEndpoint = apiUrl + 'pr/toggleAutoApprove/';

export interface ToggleAutoApprovePayload {
  repoName: string;
  orgUUID: string;
  auto_approve_on_safe: boolean;
}

export interface ToggleAutoApproveResponse {
  success: boolean;
  auto_approve_on_safe?: boolean;
  error?: string | null;
}

/**
 * Set the per-repo auto-approve-at-5/5 override for a repository. When enabled,
 * the PR bot submits a GitHub approval (never a merge) on a 5/5 "Safe to Merge"
 * review. Overrides the org-level default for this repository.
 */
export const toggleAutoApprove = async (
  payload: ToggleAutoApprovePayload
): Promise<ToggleAutoApproveResponse> => {
  try {
    const response = await postWithAuth(toggleAutoApproveEndpoint, {
      repoName: payload.repoName,
      orgUUID: payload.orgUUID,
      auto_approve_on_safe: payload.auto_approve_on_safe,
    });

    if (!response.ok) {
      throw new Error('Failed to toggle auto-approve setting');
    }

    const data = await response.json();
    if (typeof data === 'string') {
      return JSON.parse(data);
    }

    if (data?.error) {
      throw new Error(data.error);
    }

    return data;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      auto_approve_on_safe: undefined,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to toggle auto-approve setting',
    };
  }
};
